import { render } from "./PdfPreviewTechnikzentrale.vue?vue&type=template&id=4c19f51a"
import script from "./PdfPreviewTechnikzentrale.vue?vue&type=script&lang=js"
export * from "./PdfPreviewTechnikzentrale.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__